import React, { Component } from 'react'

import {
  Pagination,
  Glyphicon,
} from 'react-bootstrap';

class PaginationComponent extends Component {

  constructor(props) {
    super(props)

    this.state = {

      itensOnPage: this.props.itensOnPage,

      beginPagination: this.props.beginPagination,
      endPagination: this.props.endPagination,
      countItens: this.props.countItens,
      activePage: this.props.activePage,

      middleFirstPage: undefined,
      middleLastPage: undefined,
    }
  }

  beforePage() {

    //console.log("pagina atual: ", this.state.activePage)


    if (this.state.activePage != 1) {

      this.setState({
        beginPagination: this.state.beginPagination - this.state.itensOnPage,
        endPagination: this.state.endPagination - this.state.itensOnPage,
        activePage: this.state.activePage - 1,
      }, () => {
        this.props.onChangePage(this.state.activePage,
          this.state.beginPagination,
          this.state.endPagination)
      })

    }

    //console.log("pagina nova: ", this.state.activePage)


  }

  nextPage(numberPages) {
    if (this.state.activePage != numberPages) {
      this.setState({
        beginPagination: this.state.beginPagination + this.state.itensOnPage,
        endPagination: this.state.endPagination + this.state.itensOnPage,
        activePage: this.state.activePage + 1,
      }, () => {
        this.props.onChangePage(this.state.activePage,
          this.state.beginPagination,
          this.state.endPagination)
      })
    }
  }

  changePage(page) {

    //console.log("pagina atual: ", this.state.activePage)
    //console.log("pagina clicada: ", page)

    let multipler
    if (this.state.activePage < page) {
      multipler = page - this.state.activePage

      multipler = multipler * this.state.itensOnPage

      this.setState({
        beginPagination: this.state.beginPagination + multipler,
        endPagination: this.state.endPagination + multipler,
        activePage: page
      }, () => {
        this.props.onChangePage(this.state.activePage,
          this.state.beginPagination,
          this.state.endPagination)
      })

      //console.log("NOVA PAGINA NO CHANGE IF: ", page)

    } else {
      multipler = this.state.activePage - page

      multipler = multipler * this.state.itensOnPage

      this.setState({
        beginPagination: this.state.beginPagination - multipler,
        endPagination: this.state.endPagination - multipler,
        activePage: page
      }, () => {
        this.props.onChangePage(this.state.activePage,
          this.state.beginPagination,
          this.state.endPagination)
      })

      //console.log("NOVA PAGINA NO CHANGE ELSE: ", this.state.activePage
    }


  }

  render() {
    let pages = [];

    let numberPages = this.state.countItens / this.state.itensOnPage

    console.log("NUMBER PAGES: ", numberPages)

    if (this.state.countItens % this.state.itensOnPage > 0) {
      numberPages = numberPages + 1
    }

    numberPages = parseInt(numberPages)

    pages.push(

      <Pagination.Prev class={`item ${this.state.activePage === 1 ? 'disabled' : ''}`} onClick={() => this.beforePage()}></Pagination.Prev>

    )


    //Paginação com reticências na metade
    /*if (numberPages > 10) {

      for (let indexPage = 1; indexPage <= 5; indexPage++) {

        pages.push(

          <a class={`item ${this.state.activePage === indexPage ? 'active' : ''}`} onClick={() => this.changePage(indexPage)}>
            <p>{indexPage}</p>
          </a>
        )

      }

      pages.push(

        <a class="disabled item">
          <p>...</p>
        </a>

      )

      for (let indexPage = numberPages - 4; indexPage <= numberPages; indexPage++) {

        pages.push(

          <a class={`item ${this.state.activePage === indexPage ? 'active' : ''}`} onClick={() => this.changePage(indexPage)}>
            <p>{indexPage}</p>
          </a>
        )

      }


    }*/

    //Paginação com reticiências no fim
    //console.log("TESTE: ", this.state.activePage, " >= ", numberPages - 6)
    if (this.state.activePage < 9) {
      if (numberPages > 10) {

        for (let indexPage = 1; indexPage <= numberPages; indexPage++) {

          if (indexPage == 10) {

            pages.push(

              <Pagination.Item disabled>...</Pagination.Item>

            )

            pages.push(

              <Pagination.Item className={`item ${this.state.activePage === numberPages ? 'active' : ''}`} onClick={() => this.changePage(numberPages)}>{numberPages}</Pagination.Item>

            )

            break

          } else {
            pages.push(

              <Pagination.Item className={`item ${this.state.activePage === indexPage ? 'active' : ''}`} onClick={() => this.changePage(indexPage)}>{indexPage}</Pagination.Item>

            )
          }

        }

      } else {

        for (let indexPage = 1; indexPage <= numberPages; indexPage++) {
          pages.push(

            <Pagination.Item className={`item ${this.state.activePage === indexPage ? 'active' : ''}`} onClick={() => this.changePage(indexPage)}>{indexPage}</Pagination.Item>

          )

        }
      }

      //Indo pro fim da paginação
    } else if (this.state.activePage > numberPages - 6) {

      pages.push(

        <Pagination.Item className={`item ${this.state.activePage === 1 ? 'active' : ''}`} onClick={() => this.changePage(1)}>1</Pagination.Item>

      )

      pages.push(

        <Pagination.Item disabled>...</Pagination.Item>

      )

      for (let indexPage = numberPages - 6; indexPage <= numberPages; indexPage++) {
        pages.push(

          <Pagination.Item className={`item ${this.state.activePage === indexPage ? 'active' : ''}`} onClick={() => this.changePage(indexPage)}>{indexPage}</Pagination.Item>
        )
      }

    } else if (this.state.activePage >= 9 && this.state.activePage <= numberPages - 6) {
      pages.push(

        <Pagination.Item class={`item ${this.state.activePage === 1 ? 'active' : ''}`} onClick={() => this.changePage(1)}>1</Pagination.Item>
      )

      pages.push(

        <Pagination.Item disabled>...</Pagination.Item>

      )

      for (let indexPage = this.state.activePage - 3; indexPage <= this.state.activePage + 3; indexPage++) {
        pages.push(

          <Pagination.Item className={`item ${this.state.activePage === indexPage ? 'active' : ''}`} onClick={() => this.changePage(indexPage)}>{indexPage}</Pagination.Item>
        )
      }

      pages.push(

        <Pagination.Item disabled>...</Pagination.Item>

      )

      pages.push(

        <Pagination.Item className={`item ${this.state.activePage === numberPages ? 'active' : ''}`} onClick={() => this.changePage(numberPages)}>{numberPages}</Pagination.Item>
      )
    }

    pages.push(

      <Pagination.Next class={`item ${this.state.activePage === numberPages ? 'disabled' : ''}`} onClick={() => this.nextPage(numberPages)}></Pagination.Next>

    )

    return (
      <Pagination>
        {pages}
      </Pagination>
      // <div class="right floated ui pagination menu">

      // </div>
    );
  }
}

export default (PaginationComponent)


// WEBPACK FOOTER //
// src/utils/pagination-component.js